import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { Logo, Button } from '../Common'
import Blocked from '../Pages/SignInErrorBlocked'
import Inative from '../Pages/SignInErrorInative'
import CannotAccess from '../Pages/SignInErrorCannotAccess'
import TrialExpire from '../Pages/SignInErrorTrialExpire'

import style from './SignInError.scss'

function SignInError({ data }) {
  let content
  switch (data.status) {
    case 'bloqueado':
      content = <Blocked user={data.user} />
      break
    case 'negado':
      content = <CannotAccess />
      break
    case 'inativo':
      content = <Inative />
      break
    case 'trial_expirado':
      content = <TrialExpire />
      break
    default:
      content = null
  }
  return (
    <div className={style.wrapper}>
      <Logo className={style.logo} />
      <Link id="link-login" to="/login" className={style.link}>
        <Button id="button-login" theme="white" className={style.button} xl>
          login
        </Button>
      </Link>
      {content}
    </div>
  )
}

SignInError.propTypes = {
  data: PropTypes.shape({
    status: PropTypes.string,
    user: PropTypes.object,
  }),
}

export default SignInError



// WEBPACK FOOTER //
// ./src/components/SignInError/SignInError.js